import { Component, Fragment } from 'react';
import { Calendar, DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import { TextBox, Button as TextBoxButton } from 'devextreme-react/text-box';
import { Button, Popup } from 'devextreme-react';
import { Tarikh, StringFormat } from '../GanjiTools';
import './theme/additional.css';
import Inline from './Inline';
import './TarikhTimePicker.css';

class TarikhTimePicker extends Component {
    state = {
        value: this.props.value ?? '',
    };


    getDateObjectFromDateString = dateStr => {
        let ymdhm = dateStr == '' ? '' : typeof (dateStr) === 'string' ? dateStr : dateStr.dateObjectPer ?? '';

        ymdhm = ymdhm?.replace('T', ' ').replaceAll('-', '/');
        let ss = ymdhm?.length > 0 ? ymdhm.split(' ') : [], hms = [], hour = 0, minute = 0, second = 0;

        if (ss.length > 0)
            hms = ss[1]?.split(':') ?? [];

        if (hms?.length > 0)
            hour = Number(hms[0] ?? '0');
        if (hms?.length > 1)
            minute = Number(hms[1] ?? '0');
        if (hms?.length > 2)
            second = Number(hms[2] ?? '0');

        let date = new DateObject({
            date: ymdhm,
            format: "YYYY/MM/DD HH:mm",
            calendar: persian,
            locale: persian_fa,
            hour,
            minute,
            second
        });

        return date;
        //this.date?.toString();
        // return `${'%4d'.format(this.date.year)}/${'%02d'.format(this.date.month)}/${'%02d'.format(this.date.day)} ` +
        //     `${'%02d'.format(hour)}:${'%02d'.format(minute)}`;
    }

    getDateStringFromArray = arr => {
        if (!(arr?.length > 0))
            return '';

        return `${'%4d'.format(arr[0])}/${'%02d'.format(arr[1])}/${'%02d'.format(arr[2])} ${'%02d'.format(arr[3])}:${'%02d'.format(arr[4])}`;
    }


    getDateStringFromDateObject = dob => {
        if (!dob)
            return '';

        return `${'%4d'.format(dob.year)}/${'%02d'.format(dob.month)}/${'%02d'.format(dob.day)} ${'%02d'.format(dob.hour)}:${'%02d'.format(dob.minute)}`;
    }

    onOk = () => {
        const newValue = this.getDateStringFromDateObject(this.ymdhms).replace(' ', 'T') + ':' +
            '%02d'.format(this.ymdhms.second) + '.' + '%03d'.format(this.ymdhms.millisecond);

        const newDisplayText = this.getDateStringFromDateObject(this.smrhms);

        this.setState({
            value: newValue,
            displayText: newDisplayText,
            pickerVisible: false
        }, () => {
            (this.props.onValueChanged ?? this.props.onChanged)?.({
                value: newValue,
                dateObject: this.ymdhms,
                dateObjectPer: newValue,
                text: newDisplayText
            });
        });
    }

    componentDidMount() { // #################################################################### wrong
        this.ymdhms = this.getDateObjectFromDateString(this.state.value);
        this.setState({ displayText: this.state.value?.length > 0 ? new Tarikh(this.state.value).getString(true) : '' });
    }

    // render0() {
    //     return (
    //         <div className='ka-tarikh-picker' style={{ direction: "rtl" }}>
    //             <DatePicker
    //                 calendar={persian}
    //                 locale={persian_fa}
    //                 calendarPosition="bottom-right"
    //             />
    //         </div>
    //     )
    // }

    render() {
        //console.log(' ---- tt -----', this.state.value, this.props.value);
        return (
            < >
                <Popup rtlEnabled className='tarikh-time-picker-popup'
                    //key={'pop_' + this.state.displayText}
                    visible={this.state.pickerVisible}
                    //onHiding={e => console.log('hiding ', e)}
                    dragEnabled={false}
                    hideOnOutsideClick={false}
                    showCloseButton={false}
                    showTitle={false}
                    //title="تاریخ"
                    //container=".dx-viewport"
                    width='fit-content'
                    height='fit-content'
                //style={{ padding: '0 !important' }}
                >
                    <Calendar
                        minDate={this.props.special ? new Date() : undefined} /////////////////////
                        //maxDate={this.props.special ? new Date().getDateObject().add(this.props.isDaily !== false ? 1 : 30, 'days').toDate() : undefined}
                        value={this.ymdhms?.toDate()} readOnly={this.props.readOnly} //.state.value} 
                        plugins={[
                            <TimePicker position='bottom' hideSeconds key={'timepk'} //onSubmit={e => console.log(e)}
                            />
                        ]}
                        //format='yyyy/MM/dd HH:mm'
                        calendar={persian}
                        locale={persian_fa}
                        onChange={e => { //console.log("%05d".$(12)); // '00012'
                            let dob = new DateObject(e.toDate());
                            this.ymdhms = dob; //[dob.year, dob.month, dob.day, dob.hour, dob.minute, dob.second, dob.millisecond];
                            this.smrhms = e; //[e.year, e.month, e.day, e.hour, e.minute, e.second, e.millisecond];
                        }}
                        style={{ margin: '0' }}
                    />
                    <Inline spacing='5px' width='100%' style={{ justifyContent: 'center', padding: '5px 0' }}>
                        <Button width={'47%'} type='success' rtlEnabled icon='close'
                            onClick={() => this.onOk()}>
                            قبول
                        </Button>
                        <Button width={'47%'} type='danger' rtlEnabled icon='check'
                            onClick={() => {
                                this.setState({
                                    pickerVisible: false,
                                });
                            }}
                        >
                            رد
                        </Button>
                    </Inline>
                </Popup>

                <TextBox rtlEnabl={false} key={(this.state.value ?? 'sss') + '_' + this.state.displayText}// ?? this.state.value ?? this.props.value ?? this.props.data?.value}
                    text={this.state.displayText} // ?? this.state.value ?? this.props.value ?? this.props.data?.value}
                    rtlEnabled={false} readOnly={this.props.readOnly}
                > {/*defaultValue={this.props.data.value}*/}
                    <TextBoxButton name='tarikh' location='after' className='dx-icon-font'
                        options={{
                            icon: 'event',
                            onClick: () => this.props.readOnly ? () => { } : this.setState({ pickerVisible: true })
                        }} />
                </TextBox>
            </>
        );
    }
}

export default TarikhTimePicker;